import { useState } from "react";
import { toast } from "react-toastify";
import { getRequest } from "../Requests/requestTemplates";

type TemplateKind = "step" | "manual" | "nleg-2" | "nleg-3" | "nleg-4" | "covered-call" | "delta-hedge" | "all";

const DownloadOrderTemplate = ({ kind }: { kind: TemplateKind }) => {
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);
    try {
      const file = await getRequest<Blob>(`/v1/orderExcelTemplate/${kind}`, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.download = `order-template-${kind}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      toast.error("دریافت نمونه اکسل ناموفق بود");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={loading}
      className="text-sky-700 underline disabled:opacity-50"
    >
      {loading ? "در حال دریافت نمونه..." : "دانلود نمونه اکسل"}
    </button>
  );
};

export default DownloadOrderTemplate;
